import React, { useState, useContext } from 'react';
import axios from 'axios';
import closeImage from '../../images/delete.png';
import { BACKEND_URL } from '../../global';
import { pathFromFolderchain } from '../functions';
import { LocationContext } from '../../contextProvider';
import keycloak from '../../keycloak';

export function UploadFile(props) {
  const locationContext = useContext(LocationContext)
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState({ status: null, text: '' });
  const [uploadPercentage, setUploadPercentage] = useState(null);

  const handleFileChange = (event) => {
    let hasFileWithSameName = false
    Object.keys(props.fileMap).map(each => {
      hasFileWithSameName = hasFileWithSameName || props.fileMap[each].name == removeFileExtension(event.target.files[0].name)
      // props.folderChain[props.folderChain.length - 1].childrenIds.map(each => {
      // hasFileWithSameName = hasFileWithSameName || props.fileMap[each].name == removeFileExtension(event.target.files[0].name)
    })
    if (hasFileWithSameName) {
      setUploadStatus({ status: 400, text: 'Υπάρχει ήδη ένα αρχείο με αυτό το όνομα' });
      // setUploadStatus({ status: 400, text: 'Υπάρχει ήδη ένα αρχείο με αυτό το όνομα σε αυτό το φάκελο' });
      setSelectedFile(null)
    } else {
      setUploadStatus({ status: null, text: '' });
      setSelectedFile(event.target.files[0]);
    }
  };

  function removeFileExtension(filename) {
    if (typeof filename !== 'string') return '';
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) return filename; // No extension found
    return filename.substring(0, lastDotIndex);
  }

  function updateState(data) {
    console.log(data)
    let newFile = data
    const currentFolderId = props.folderChain[props.folderChain.length - 1].id
    const newFileMap = { ...props.fileMap };
    let newFolderChain = [...props.folderChain]
    newFileMap[newFile.created_at] = {
      color: "rgb(195, 186, 240)",
      id: newFile.created_at,
      interview_id: newFile.id,
      isDir: false,
      modDate: newFile.created_at,
      name: newFile.interview_id,
      parentId: currentFolderId,
      path: newFile.path,
      size: true,
      transcribed: false,
      transcriptionStatus: "NOT_TRANSCRIBED",
      groups: newFile.groups
    };

    // Update parent folder to reference the new folder.
    const parent = newFileMap[currentFolderId];
    newFileMap[currentFolderId] = {
      ...parent,
      childrenIds: [...parent.childrenIds, newFile.created_at],
      childrenCount: parent.childrenCount + 1
    };
    newFolderChain[newFolderChain.length - 1] = newFileMap[currentFolderId]
    props.updateFileMap(newFileMap)
    props.updateFolderChain(newFolderChain)
    locationContext.setFolderChain(newFolderChain)
  }


  const handleUpload = async () => {
    setUploadStatus();
    if (!selectedFile) {
      setUploadStatus({ status: 400, text: 'Δεν έχει επιλεγεί αρχείο' });
      return;
    }
    const path = pathFromFolderchain(props.path);
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('path', path);
    try {
      setUploadStatus({ status: 1, text: '' });
      const config = {
        headers: {
          Authorization: `Bearer ${keycloak.token}`
        },
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadPercentage(percentCompleted);
        },
      };
      const response = await axios.post(`${BACKEND_URL}/upload_audio`, formData, config);
      console.log(response);
      setUploadPercentage(null);
      if (response.status == 200) {
        setUploadStatus({ status: 200, text: 'Το αρχείο ανέβηκε με επιτυχία!' });
        updateState(response.data);
        setTimeout(() => {
          setUploadPercentage(0);
          setSelectedFile(null);
          document.getElementById('file-input').value = ''
          setUploadStatus({ status: null, text: '' })
          document.getElementById('modal-upload').classList.add('hidden')
        }, 1500);
      } else {
        setUploadStatus({ status: 400, text: 'Το αρχείο δεν ανέβηκε' });
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setUploadStatus({ status: 400, text: 'Υπήρξε κάποιο πρόβλημα' });
    }
  };

  return (
    <div id="modal-upload" className="fixed hidden z-10 w-screen h-screen top-0 left-0 bg-white/60 flex items-center justify-center">
      <div className="shadow-xl overflow-hidden flex flex-col items-center justify-center rounded-xl bg-white w-6/12 min-w-[400px] min-h-fit px-2">
        <span className="flex w-full p-2 mt-2">
          <div className="ml-auto mr-2">
            <img onClick={() => { setUploadPercentage(0); setSelectedFile(null); setUploadStatus({ status: null, text: '' }); document.getElementById('modal-upload').classList.add('hidden') }} src={closeImage} className="w-[1em] h-[1em] rounded-lg hover:shadow-md hover:shadow-purple-500 cursor-pointer" />
          </div>
        </span>
        <span className="font-bold text-gray-800/80 mt-5 mb-14 text-center">Αποστολή ηχητικού αρχείου</span>
        <div className="mb-auto flex flex-col items-center justify-center w-full mb-auto">
          <input id="file-input" type="file" onChange={handleFileChange} className="hidden" />
          <div className="flex flex-row w-10/12 h-fit">
            <button onClick={() => { document.getElementById('file-input').click(); }} disabled={uploadStatus.status == 1} className={`py-1 w-fit font-bold h-[48px] rounded-l-lg outline-none px-2 flex items-center justify-center bg-rotten-light ${uploadStatus.status == 1 ? '' : 'hover:bg-rotten-dark hover:shadow-lg'} text-gray-800`}>Επιλογή</button>
            <p onClick={() => { document.getElementById('file-input').click(); }} className="min-w-0 cursor-pointer h-[48px] py-3 w-10/12 border border-1 border-purple-200/80 rounded-r-xl px-4" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {selectedFile && selectedFile.name ? selectedFile.name : 'Δεν έχει επιλεγεί αρχείο'}
            </p>
          </div>
          <div className="flex flex-row w-full items-center justify-center gap-2 mt-4">
            <button onClick={handleUpload} disabled={uploadStatus.status == 1} className={`h-fit py-1 w-4/12 font-bold h-[48px] rounded-lg outline-none px-2 flex items-center justify-center ${uploadStatus.status == 1 ? '' : 'hover:bg-rotten-dark hover:shadow-lg'} bg-rotten-light text-gray-800/80`}>Αποστολή</button>
          </div>
          <div className={`${uploadStatus.status == 400 ? 'font-bold text-red-400' : uploadStatus.status == 200 ? 'font-bold text-pale-green' : ''} h-8 break-all flex flex-wrap py-1 w-fit my-2 text-center rounded-xl p-4`}>
            {uploadStatus.status ? `${uploadStatus.text}` : ''}
          </div>
        </div>
        <div id="progress-bar" className={`skeleton mr-auto h-[7px] ${uploadStatus.status == 400 ? 'bg-red-400' : 'bg-pale-green'}`} style={{ animation: 'skeleton 3.5s ease-in-out infinite', width: `${uploadPercentage}%` }} />
      </div>
    </div>
  );
}

export default UploadFile;
